import React from "react"
import prettierNumber from "utils/prettier-number"
import { useClientContext } from ".."
import styles from "../application-group.module.scss"
import ResultBox from "../components/result-box"
import global from "global"
import request from "request"
import { toast } from "react-toastify"

const Main = () => {
  const { group } = useClientContext()
  const [microData, setMicroData] = React.useState<global.microData>()

  React.useEffect(() => {
    request
      .get("/admin/constant_values")
      .then((res) => res.data)
      .then((d) => setMicroData(d))
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message ||
          error.message ||
          "An unknown error occurred."
        toast.error(`Error fetching constant values: ${errorMessage}`)
      })
  }, [])

  return (
    <>
      <div className={styles.main}>
        <div className={styles.title}>Group common info</div>
        {microData && (
          <>
            <div className={styles.item}>
              <div className={styles.key}>Amount</div>
              <div className={styles.value}>
                {prettierNumber(group.applications[0]?.loanAmount)} JOD
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.key}>Duration</div>
              <div className={styles.value}>
                {group.applications[0]?.scoring_log?.loanDuration} mon.
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.key}>Interest rate (annual)</div>
              <div className={styles.value}>
                {Number(group.applications[0]?.interestRate)}%
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.key}>Branch</div>
              <div className={styles.value}>
                {group.applications[0].scoring_log?.branch}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.key}>Product</div>
              <div className={styles.value}>
                {group.applications[0]?.product}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.key}>Threshold</div>
              <div className={styles.value}>
                {microData.threshold !== undefined
                  ? microData.threshold * 100 + "%"
                  : "N/A"}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.key}>
                Over Indebtedness Ratio Threshold
              </div>
              <div className={styles.value}>
                {microData.hard_oir_threshold !== undefined
                  ? microData.hard_oir_threshold * 100 + "%"
                  : "N/A"}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.key}>DBR Threshold</div>
              <div className={styles.value}>
                {microData.dbr_threshold !== undefined
                  ? `${(Number(microData?.dbr_threshold) * 100)?.toFixed(2)}%`
                  : "N/A"}
              </div>
            </div>
          </>
        )}
      </div>
      <ResultBox />
    </>
  )
}

export default Main
